export function isBoolean(param?: any) {
  return typeof param === 'boolean';
}

export function isTrue(param?: any) {
  return param === true;
}

export function isFalse(param?: any) {
  return param === false;
}

export function isArray(param?: any) {
  return Array.isArray(param);
}

export function isString(param?: any) {
  return typeof param === 'string';
}

export function isNotEmptyString(param?: any) {
  return isString(param) && param.length > 0;
}

export function isNotEmptyArray(param?: any) {
  return isArray(param) && param.length > 0;
}

export function isObject(param?: any) {
  return typeof param === 'object' && param !== null;
}

export function isNotEmptyObject(param?: any) {
  return isObject(param) && Object.keys(param).length > 0;
}

export function isNotEmpty(param?: any) {
  return (
    isNotEmptyString(param) ||
    isNotEmptyArray(param) ||
    isNumber(param) ||
    isBoolean(param) ||
    isNotEmptyObject(param)
  );
}

export function isInteger(param?: any) {
  return Number.isInteger(param);
}

export function isPositiveInteger(param?: any) {
  return isInteger(param) && param >= 0;
}

export function isNegativeInteger(param?: any) {
  return isInteger(param) && param < 0;
}

export function isNumber(param?: any) {
  return typeof param === 'number';
}

export function isPositiveNumber(param?: any) {
  return isNumber(param) && param >= 0;
}

export function isNegativeNumber(param?: any) {
  return isNumber(param) && param < 0;
}
